(function () {
    let lastProcessedVariantId = null;

    init();

    function init() {
        const bannerComponents = document.querySelectorAll('.last-order-banner');
        const countdownBannerComponents = [];

        for (const banner of bannerComponents) {
            const bannerTextComponent = banner.querySelector('p');
            const deliveryText = banner.dataset.deliveryText;
            const bannerType = banner.dataset.bannerType;

            if (!banner.dataset.deliveryDateInSeconds) continue;

            const deliveryDateTimestamp = parseInt(banner.dataset.deliveryDateInSeconds) * 1000;

            if (isNaN(deliveryDateTimestamp)) {
                console.error('Invalid timestamp');
                continue;
            }

            if (bannerType === 'countdown') {
                countdownBannerComponents.push({
                    banner,
                    bannerTextComponent,
                    deliveryText,
                    localDateTimestamp: deliveryDateTimestamp
                });
                performUpdate(deliveryDateTimestamp, bannerTextComponent, deliveryText, true);
                continue;
            }

            // Static banner logic
            if (bannerTextComponent) {
                bannerTextComponent.innerHTML = deliveryText.replace('DATE_PLACEHOLDER', convertDateToDDMM(new Date(deliveryDateTimestamp)));
                banner.style.display = 'inline-flex';
            }
        }

        if (window.bannerCountdownInterval) {
            clearInterval(window.bannerCountdownInterval);
        }

        if (countdownBannerComponents.length) {
            if (countdownBannerComponents.length === 1) {
                countdownBannerComponents[0].banner.style.display = 'inline-flex';
            }
            startCountdown(countdownBannerComponents);

        }

        initialBannerUpdate();
    }

    function performUpdate(countdownEndDateTimestamp, bannerTextComponent, deliveryText, overrideDisplayCheck = false) {
        if(!bannerTextComponent) return;

        const now = Date.now();
        const dist = countdownEndDateTimestamp - now;

        if (dist < 0) {
            if(bannerTextComponent.parentElement) {
                bannerTextComponent.parentElement.style.display = 'none';
            }
            return;
        }

        if (overrideDisplayCheck || bannerTextComponent.parentNode.style.display !== 'none') {
            const hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((dist % (1000 * 60)) / 1000);

            bannerTextComponent.innerHTML = deliveryText.replace('DATE_PLACEHOLDER', `${hours > 0 ? `${hours}h ` : ''}${minutes}m ${seconds}s`);
        }
    }

    function startCountdown(countdownBanners) {
        window.bannerCountdownInterval = setInterval(() => {

            for (let i = countdownBanners.length - 1; i >= 0; i--) {
                if (!countdownBanners[i].banner.isConnected) {
                    countdownBanners.splice(i, 1);
                }
            }

            if (countdownBanners.length === 0) {
                clearInterval(window.bannerCountdownInterval);
                return;
            }

            for (const countdownBanner of countdownBanners) {
                const { bannerTextComponent, localDateTimestamp, deliveryText } = countdownBanner;
                performUpdate(localDateTimestamp, bannerTextComponent, deliveryText);
            }

        }, 1000);
    }

    function convertDateToDDMM(date) {
        const day = date.getDate();
        const month = date.toLocaleString('en-US', { month: 'long' });
        let suffix = 'th';

        if (day < 11 || day > 13) {
            switch (day % 10) {
                case 1: suffix = 'st'; break;
                case 2: suffix = 'nd'; break;
                case 3: suffix = 'rd'; break;
            }
        }
        return `${day}${suffix} ${month}`;
    }

    function updateBanners(variant) {
        if (!variant || variant.id === lastProcessedVariantId) return;
        lastProcessedVariantId = variant.id;

        const bookCover = variant.title.toLowerCase();
        // Always re-query here because DOM might have changed
        const lastOrderBanners = document.querySelectorAll('.last-order-banner');

        for (const banner of lastOrderBanners) {
            const bookCoverTarget = banner.dataset.bookVariantType;
            if (!bookCoverTarget) continue;

            const bookFormat = `book_${bookCover}`;
            banner.style.display = (bookCoverTarget === bookFormat) ? 'inline-flex' : 'none';
        }
    }

    if (!window.hasLastOrderBannerListener) {
        document.addEventListener('cc-variant-updated', function (e) {
            if (e.detail && e.detail.variant && e.detail.variant.id) {
                updateBanners(e.detail.variant);
            }
        });
        window.hasLastOrderBannerListener = true;
    }

    function initialBannerUpdate(){
        const productForm = document.querySelector('.product-form');
        if (productForm) {
            try {
                const productId = productForm.dataset.productId;
                const currentVariantInput = productForm.querySelector('[name="id"]');
                const jsonScript = document.getElementById(`ProductJson-${productId}`);

                if (jsonScript && currentVariantInput) {
                    const productData = JSON.parse(jsonScript.innerHTML);
                    const currentVariantId = parseInt(currentVariantInput.value);
                    const initialVariant = productData.variants.find(v => v.id === currentVariantId);

                    if (initialVariant) updateBanners(initialVariant);
                }
            } catch (e) {
                console.error("LOD Banner: Unable to detect initial variant.", e);
            }
        }
    }
})();